import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-resume',
  templateUrl: './resume.component.html',
  styleUrls: ['./resume.component.sass']
})
export class ResumeComponent implements OnInit {
  
  @Input() screenPaymentType;
  @Input() dataPay;
  constructor() { }

  ngOnInit() {
  }

}
